import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";

const AMBER = [180, 83, 9];
const STONE = [87, 83, 78];
const rp = (n) => "Rp " + Math.round(Number(n) || 0).toLocaleString("id-ID");
const tgl = (iso) => (iso ? new Date(iso).toLocaleString("id-ID", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit", timeZone: "Asia/Jakarta" }) + " WIB" : "-");

const drawLogo = (doc, x, y) => {
  doc.setDrawColor(...AMBER);
  doc.setLineWidth(0.6);
  doc.setLineDashPattern([1.4, 1], 0);
  doc.circle(x, y, 7, "S");
  doc.setLineDashPattern([], 0);
  doc.setTextColor(...AMBER);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(10);
  doc.text("EM", x, y + 1.3, { align: "center" });
  doc.setTextColor(28, 25, 23);
  doc.setFontSize(15);
  doc.text("EllMom", x + 10, y - 0.5);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(9);
  doc.setTextColor(...STONE);
  doc.text("Handmade", x + 10, y + 4);
};

const header = (doc, o, store) => {
  drawLogo(doc, 21, 22);
  doc.setFontSize(8.5);
  doc.setTextColor(...STONE);
  doc.text(doc.splitTextToSize(store.address, 80), 14, 36);
  doc.text(`WhatsApp: ${store.phone}`, 14, 45);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(20);
  doc.setTextColor(28, 25, 23);
  doc.text("INVOICE", 196, 20, { align: "right" });
  doc.setFont("helvetica", "normal");
  doc.setFontSize(9);
  doc.setTextColor(...STONE);
  doc.text(`No. Pesanan: ${o.order_id}`, 196, 28, { align: "right" });
  doc.text(`Tanggal pesan: ${tgl(o.created_at)}`, 196, 33, { align: "right" });
  doc.text(`Tanggal bayar: ${tgl(o.paid_at)}`, 196, 38, { align: "right" });
  doc.setFillColor(240, 253, 244);
  doc.roundedRect(166, 41, 30, 7, 2, 2, "F");
  doc.setTextColor(22, 101, 52);
  doc.setFont("helvetica", "bold");
  doc.text("LUNAS", 181, 45.8, { align: "center" });
  doc.setDrawColor(231, 229, 228);
  doc.setLineWidth(0.3);
  doc.line(14, 52, 196, 52);
};

const parties = (doc, o) => {
  const r = o.recipient || {};
  const dest = [r.address, r.city, r.province, r.postal_code].filter(Boolean).join(", ");
  doc.setFontSize(8.5);
  doc.setTextColor(...STONE);
  doc.setFont("helvetica", "normal");
  doc.text("Pemesan", 14, 60);
  doc.text("Dikirim ke", 110, 60);
  doc.setTextColor(28, 25, 23);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(10);
  doc.text(o.sender?.name || "-", 14, 66);
  doc.text(r.name || "-", 110, 66);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(9);
  doc.text(doc.splitTextToSize(dest || "-", 86), 110, 71);
  doc.text(`Ekspedisi: ${o.courier.name} ${o.courier.service}`.trim(), 14, 71);
  if (o.tracking_number) doc.text(`No. Resi: ${o.tracking_number}`, 14, 76);
};

export function buildInvoice(o, store) {
  const doc = new jsPDF({ unit: "mm", format: "a4" });
  header(doc, o, store);
  parties(doc, o);
  autoTable(doc, {
    startY: 86,
    head: [["Produk", "Variasi", "Jml", "Harga", "Subtotal"]],
    body: o.items.map((i) => [i.name, Object.values(i.variant || {}).join(", ") || "-", String(i.qty), rp(i.unit_price), rp(i.subtotal)]),
    styles: { fontSize: 9, cellPadding: 2.5, textColor: [28, 25, 23] },
    headStyles: { fillColor: AMBER, textColor: 255 },
    columnStyles: { 2: { halign: "right", cellWidth: 14 }, 3: { halign: "right", cellWidth: 30 }, 4: { halign: "right", cellWidth: 32 } },
    margin: { left: 14, right: 14 },
  });
  let y = doc.lastAutoTable.finalY + 8;
  const row = (label, value, bold = false) => {
    doc.setFont("helvetica", bold ? "bold" : "normal");
    doc.setFontSize(bold ? 11 : 9.5);
    doc.setTextColor(28, 25, 23);
    doc.text(label.length > 34 ? label.slice(0, 33) + "..." : label, 120, y);
    doc.text(value, 196, y, { align: "right" });
    y += bold ? 8 : 6;
  };
  row("Subtotal", rp(o.subtotal));
  row(`Ongkir ${o.courier.name} ${o.courier.service} (${o.courier.weight_kg || 1} kg)`, rp(o.shipping_cost));
  if (o.tax?.charged_to_buyer && o.tax.amount > 0) row(`${o.tax.name} (${o.tax.rate_percent}%)`, rp(o.tax.amount));
  doc.setDrawColor(231, 229, 228);
  doc.line(120, y - 3, 196, y - 3);
  y += 2;
  row("Total dibayar", rp(o.total), true);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(9);
  doc.setTextColor(...STONE);
  doc.text("Metode pembayaran: QRIS (terverifikasi otomatis)", 14, y + 4);
  doc.setFontSize(8.5);
  doc.text("Terima kasih telah berbelanja karya handmade di EllMom Handmade.", 105, 282, { align: "center" });
  return doc;
}

export const downloadInvoice = (o, store) => buildInvoice(o, store).save(`Invoice-${o.order_id}.pdf`);
